import { mainServer, BASIC_AUTH_HEADER } from '../../variables/config';


export const request_email_confirmation = async(data) => {
  mainServer.defaults.headers.common['Authorization'] = BASIC_AUTH_HEADER
  const response = await mainServer.post(`/registration/confirm`,data)
  return response.data.data
}